import store from 'redux/store';
import { showDialog } from 'dialogs';
import EditWorkerModal, { type WorkerFormProps } from '../EditWorkerModal';

export type ShowEditWorkerArgs = { readonly mode: 'create' } | { readonly mode: 'edit'; readonly id: number };

// The modal takes the full record inline; read it from the list the store
// already holds, by worker id.
const findWorker = (id: number): WorkerFormProps | null =>
  (store.getState().workers.items.find((w: any) => w.worker_id === id) as WorkerFormProps | undefined) ?? null;

/** Open the worker create / edit modal via showDialog. */
export const showEditWorker = (args: ShowEditWorkerArgs): void => {
  const worker = args.mode === 'create' ? null : findWorker(args.id);
  showDialog((close) => <EditWorkerModal show handleClose={close} mode={args.mode} worker={worker} />);
};
